import {ResultHelper} from '../../../helper/result.helper';

export class StatisticMatch
{
  database: number;
  matchId: number;
  eventId: number;
  parentMatchId: number;
  date: string; // ISO-String (z. B. 2025-01-10T12:00:00)
  year: number;
  month: number;
  quarter: number;
  phaseName: string;
  roundName: string;
  participant1Name: string;
  participant2Name: string;
  parentParticipant1Name: string;
  parentParticipant2Name: string;
  parentTeam1Id: number;
  parentTeam2Id: number;

  setsHome: number | null;
  setsAway: number | null;
  legsHome: number | null;
  legsAway: number | null;
  setsBestof: number | null;
  setsTotal: number | null;
  legsBestof: number | null;
  legsTotal: number | null;
  matchmodePoints: number;
  matchmodeInCd: string;
  matchmodeOutCd: string;
  duration: number | null;
  matchTypeCd: string;
  eventTypeCd: string;
  eventKindCd: string;
  dartTypeCd: string;

  participants: string;
  result: string;
  result1: string;
  result2: string;
  participant1Winner: boolean;
  participant2Winner: boolean;
  participant1Self: boolean;
  participant2Self: boolean;

  public static init(data: StatisticMatch): void
  {
    if (!data)
      return;

    if (data.participant1Name && data.participant2Name)
      data.participants = data.participant1Name + ' - ' + data.participant2Name;

    data.result = ResultHelper.formatResult(data.setsHome, data.setsAway, data.legsHome, data.legsAway);
    data.result1 = ResultHelper.formatResult(data.setsHome, data.setsAway, data.legsHome, data.legsAway, undefined, 1);
    data.result2 = ResultHelper.formatResult(data.setsHome, data.setsAway, data.legsHome, data.legsAway, undefined, 2);
    data.participant1Self = data.result1 > data.result2;
    data.participant2Self = data.result1 > data.result2;
    data.participant1Winner = data.result1 > data.result2;
    data.participant2Winner = data.result2 > data.result1;
  }
}
